import { Grid } from "@mui/material";
import { poisBountyAssets } from "assets/cdn";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useEnvContext } from "contexts";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { FeaturesFlags } from "helpers";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import { usePostPbMetadataMutation } from "redux/apis";
import {
	onClosePopUp,
	onOpenPopUp,
	onPBV3change,
	selectPoisBountyV3State
} from "redux/slices";
import {
	Background,
	Body,
	Button,
	Container,
	Description,
	Header,
	Title
} from "./styles";

interface PBV3RewardsCollectedProps {}

export const PBV3RewardsCollected: React.FC<PBV3RewardsCollectedProps> = () => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const scale = useCalculateScale(400, 500);
	const { isFeatureFlagEnabled } = useEnvContext();
	const [postPbMetadata] = usePostPbMetadataMutation();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { tracker, inactiveTrackers } = useAppSelector(selectPoisBountyV3State);

	const onClose = async () => {
		dispatch(onClosePopUp());
		if (isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2)) {
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "reward_claimed_popup_clicked",
				event_type: "pois_bounty",
				action: "reward_claimed_popup_clicked",
				source: "pois_bounty_menu",
				event_id: tracker?.eventId
				//reward_id: lastReward?.reward?.rewardId ?? ""
			});
		}
		if (inactiveTrackers) {
			await postPbMetadata({
				eventId: tracker?.eventId ?? "",
				key: "hasSeenClubLeavePopup",
				value: true
			});
			if (inactiveTrackers.eventType === "club") {
				dispatch(onOpenPopUp("pb-v3-club-change::0"));
			}
			if (inactiveTrackers.eventType === "user") {
				dispatch(onOpenPopUp("pb-v3-club-change::1"));
			}
			dispatch(onPBV3change({ inactiveTrackers: undefined }));
		}
	};

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onClose} />
			<Header>
				<Background
					src={getImage(poisBountyAssets.v3.rewardsCollected.background)}
				/>
			</Header>
			<Body>
				<Title>
					Collect your
					<br /> items!
				</Title>
				<Description>
					Your Poi’s Bounty rewards are waiting
					<br /> in your in-game inbox to be collected!
				</Description>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						/* sm={isMobile ? 6 : 12} */
						display="flex"
						justifyContent="center"
					>
						<Button
							themeColor="secondary"
							onClick={onClose}
							sx={{
								minWidth: { xs: "80%" /* sm: isMobile ? "100%" : "80%" */ }
							}}
						>
							Yay!
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="pois_bounty_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
